import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/breadcrumb";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Box, Container, Link } from "@chakra-ui/react";
import NextLink from "next/link";
import { Chrono } from "react-chrono";
import { Footer } from "../../components/Footer";
import { Meta } from "../../components/Meta";
import { getAllVictories } from "../../lib/getVictory";

export default function Vitorias(props) {
    const items = props.victories.map((item) => {
        const victoryAt = new Date(item.victory_at + ' 00:00:00')
        const link = process.env.NEXT_PUBLIC_PROJECT_URL + '/vitorias/' + item.slug

        return {
            key: item.id,
            title: victoryAt.getFullYear(),
            cardTitle: <NextLink href={link} passHref><Link>{item.title}</Link></NextLink>,
            cardSubtitle: <NextLink href={link} passHref><Link>{item.social_title}</Link></NextLink>,
            cardDetailedText: <NextLink href={link} passHref><Link>{item.social_description}</Link></NextLink>,
        }
    })

    return (<>
        <Meta
            title={"Algumas de nossas vitórias"}
            socialTitle={"Vitórias do IPCO"}
            description={"Algumas vitórias do Instituto Plínio Corrêa de Oliveira"}
            pageType={"website"}
            image={"https://campanhas.ipco.org.br/Logo-IPCO.png"}
            createdAt={new Date()}
        />

        <Container maxW="800px" mt="3rem">
            <Box>
                <Breadcrumb spacing={1} mb="1rem" separator={<ChevronRightIcon color="gray.500" />}>
                    <BreadcrumbItem>
                        <NextLink href={"/"} passHref>
                            <BreadcrumbLink>Início</BreadcrumbLink>
                        </NextLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem>
                        <BreadcrumbLink href="#">Vitórias</BreadcrumbLink>
                    </BreadcrumbItem>
                </Breadcrumb>
            </Box>
            <Chrono
                items={items}
                mode={"VERTICAL_ALTERNATING"}
                theme={{
                    primary: "#053C5E", secondary: "#053C5E", cardBgColor: "#E2E8F0", titleColor: "white"
                }}
                hideControls={true}
                useReadMore={false}
            />

        </Container>
        <footer><Footer /></footer>
    </>)
}


export async function getStaticProps() {
    const res = await getAllVictories()

    const { victories } = res

    if (res.status === 404) {
        return {
            notFound: true,
        }
    }

    return {
        props: {
            victories
        },
        revalidate: 10 //tempo em segundos
    }
}